<template>
  <nuxt-link
    v-if="category.slug"
    class="category-name-card"
    :to="`/${category.slug}/`"
  >
    <div class="category-name-card__text">
      {{ category.name }}
    </div>
    <UiResponsiveImage
      class="category-name-card__image"
      :src="img"
      :alt="category.name"
      :title="category.name"
      draggable="false"
      :adaptive-image="img !== '/static/images/no-img.svg'"
      :mobile-sizes="{ width: 173, height: 96 }"
      :desktop-sizes="{ width: 346, height: 192 }"
    />
    <debug-info v-if="debugPanel" :data="category" />
  </nuxt-link>
</template>

<script lang="ts" setup>
import type { ModelCategory } from '~/interfaces/api';
import { useGlobalStore } from '~/stores/global';

const globalStore = useGlobalStore();
const debugPanel = computed(() => globalStore.debugPanel);

const props = defineProps({
  category: {
    type: Object as () => ModelCategory,
    required: true,
  },
});

const img = computed(() => {
  if (props.category?.image) return props.category.image;
  return '/static/images/no-img.svg';
});
</script>
<style scoped lang="scss">
.category-name-card {
  position: relative;
  height: 166px;
  background: $achromatic-card-bg;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-radius: 8px;
  @include md-block {
    height: 176px;
  }
  @include xl-block {
    height: 216px;
  }

  &__text {
    padding: 8px 8px 0;
    width: 100%;
    height: 72px;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    overflow-wrap: anywhere;
    color: $achromatic-black;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: 16px;
    -webkit-hyphens: auto;
    -ms-hyphens: auto;
    hyphens: auto;
    @include sm-block {
      -webkit-line-clamp: 3;
      padding: 12px 12px 0;
      font-size: 14px;
      line-height: 20px;
      -webkit-hyphens: none;
      -ms-hyphens: none;
      hyphens: none;
    }
    @include xl-block {
      padding: 16px 16px 0;
      height: 76px;
      font-size: 16px;
      line-height: 20px;
    }
  }

  &__image {
    width: 100%;
    height: 76px;
    @include sm-block {
      height: 96px;
    }
    @include xl-block {
      height: 132px;
    }
  }

  :deep(.debug-info) {
    bottom: 0;
  }
}
</style>
